import Vue from 'vue';
export default Vue.extend({
    name: 'fixedTools',
    data: function () {
        return {
            isShowReturnTop: false,
        };
    },
    mounted: function () {
        window.addEventListener('scroll', this.handleScroll);
    },
    methods: {
        toFeedback: function () {
            this.$router.push({ name: 'helpCenterFeedback' });
        },
        getScrollTop: function () {
            return (window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop);
        },
        handleScroll: function () {
            var scrollTop = this.getScrollTop();
            scrollTop > 0
                ? (this.isShowReturnTop = true)
                : (this.isShowReturnTop = false);
        },
        returnTop: function () {
            document.documentElement.scrollTop = 0;
        },
    },
});
